var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.969,
    height: 14.968,
    viewBox: "0 0 14.969 14.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    d: "M3.351,14.969H.247V4.975h3.1ZM1.8,3.612A1.806,1.806,0,1,1,3.594,1.8,1.812,1.812,0,0,1,1.8,3.612ZM14.965,14.969h-3.1V10.1c0-1.159-.023-2.646-1.613-2.646-1.613,0-1.861,1.26-1.861,2.563v4.948h-3.1V4.975H8.271V6.339h.043a3.261,3.261,0,0,1,2.936-1.614c3.141,0,3.718,2.068,3.718,4.755v5.49Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.a24c52fea9793da89e2ddb028082fdc1.svg";
export { ForwardRef as ReactComponent };